import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "bg-gray-950/80 space-y-6 py-5",
  ref: "targetElement"
}
const _hoisted_2 = { class: "w-full px-3 md:px-0" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = { class: "grid grid-cols-12 gap-3 md:gap-5 xl:gap-0 w-full px-3 md:px-0" }
const _hoisted_5 = { class: "col-span-9 md:col-span-10 xl:col-span-11 xl:px-5" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-1.5 sm:gap-2 xl:gap-3"
}
const _hoisted_7 = { class: "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-1.5 sm:gap-2 xl:gap-3" }
const _hoisted_8 = ["title", "onClick"]
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "absolute z-10 bottom-0 left-1/2 -translate-x-1/2 w-full text-white text-[11px] font-semibold truncate bg-black/60 pl-3" }
const _hoisted_11 = { class: "col-span-3 md:col-span-2 xl:col-span-1" }

export function render(_ctx, _cache) {
  const _component_Message = _resolveComponent("Message")
  const _component_GameNavbar = _resolveComponent("GameNavbar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Error "),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "error",
          closable: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.error), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" Products "),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              _cache[2] || (_cache[2] = _createElementVNode("label", {
                for: "default-search",
                class: "mb-2 text-sm font-medium text-gray-900 sr-only"
              }, "ค้นหา", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none" }, [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-gray-500",
                    "aria-hidden": "true",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 20 20"
                  }, [
                    _createElementVNode("path", {
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                    })
                  ])
                ], -1 /* HOISTED */)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchQuery) = $event)),
                  type: "search",
                  id: "default-search",
                  class: "block w-full p-4 ps-10 text-sm bg-[#000000d9]! text-amber-100! border border-[#29ab60]! rounded-lg focus:ring-primary focus:border-primary",
                  placeholder: "ค้นหา..."
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.searchQuery]
                ])
              ])
            ])
          ])
        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createCommentVNode(" Product "),
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-lg text-amber-100 font-semibold mb-2" }, "รายการหวย", -1 /* HOISTED */)),
          _createCommentVNode(" Product Loading "),
          (_ctx.loadingProducts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(30, (n) => {
                  return _createElementVNode("div", {
                    key: 'game-skeleton-' + n,
                    class: "h-24 bg-gray-200 animate-pulse rounded"
                  })
                }), 64 /* STABLE_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" Product List "),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsList, (product) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: product.productCode,
                      class: "relative z-0 w-full border rounded xl:rounded-2xl shadow-sm transition bg-black hover:bg-primary hover:text-primary cursor-pointer overflow-hidden!",
                      title: product.productName?.toLocaleUpperCase(),
                      onClick: $event => (_ctx.clickGame(product.productCode))
                    }, [
                      _createElementVNode("img", {
                        class: "static z-0 w-full h-full top-0 left-0",
                        src: product.logo?.default,
                        alt: product.productName?.toLocaleUpperCase()
                      }, null, 8 /* PROPS */, _hoisted_9),
                      _createElementVNode("h4", _hoisted_10, _toDisplayString(product.productName?.toUpperCase()), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_8))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_GameNavbar)
      ])
    ])
  ], 512 /* NEED_PATCH */))
}